<template>
  <el-dialog
    v-model="dialogVisible"
    :close-on-click-modal="false"
    title="修改密码"
    width="500"
    :before-close="handleClose"
  >
    <el-form
      :model="form"
      ref="formRef"
      label-width="auto"
      style="max-width: 600px"
    >
      <el-form-item
        label="原密码"
        prop="old_passwd"
        :rules="[
        {
          required: true,
          message: '请输入原密码',
          trigger: 'blur',
        },
        {
          min: 6,
          max: 16,
          message: '长度在 6 到 16 个字符',
          trigger: 'blur'
        },
        {
          pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/,
          message: '包含数字，包含字母',
          trigger: 'blur'
        }

      ]"
      >
        <el-input
          v-model="form.old_passwd"
          type="password"
          show-password
        />

      </el-form-item>
      <el-form-item
        label="新密码"
        prop="passwd"
        :rules="[
        {
          required: true,
          message: '请输入新密码',
          trigger: 'blur',
        },
        {
          min: 6,
          max: 16,
          message: '长度在 6 到 16 个字符',
          trigger: 'blur'
        },
        {
          pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/,
          message: '包含数字，包含字母',
          trigger: 'blur'
        }

      ]"
      >
        <el-input
          v-model="form.passwd"
          type="password"
          show-password
        />
        <div class="passwordTilBox">
          <el-icon>
            <QuestionFilled />
          </el-icon>
          <span class="pwd_chk_span2">至少六位字符，包含字母，数字</span>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button
          type="primary"
          @click="handleEditPwd"
        >
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import apiFun from '@/api/user.js'
const dialogVisible = ref(false)
const formRef = ref()

const form = reactive({
  passwd: '',
  old_passwd: ''
})

/**
 * 打开弹窗
 */
function handleOpen() {
  dialogVisible.value = true
}

/**
 * @param done 关闭弹窗
 */
const handleClose = (done) => {
  formRef.value.resetFields()
  formRef.value.clearValidate()
  dialogVisible.value = false
}
/**
 * 修改密码
 */
function handleEditPwd() {
  formRef.value.validate(async (valid) => {
    if (valid) {
      const params = {
        passwd: form.passwd,
        old_passwd: form.old_passwd
      }
      const res = await apiFun.editPwd(params)
      console.log(res)
      if (res.code === 200) {
        ElMessage({
          message: '密码修改完成',
          type: 'success'
        })
        handleClose()
      } else {
        ElMessage({
          message: res.msg,
          type: 'error'
        })
      }
    } else {
      console.log('修改失败')
    }
  })
}

/**
 * 向外面暴露方法
 */
defineExpose({ handleOpen })
</script>

<style lang="scss">
.passwordTilBox {
  display: flex;
  align-items: center;
  gap: 10px;

  .pwd_chk_span2 {
    color: #ccc;
    font-size: 11px;
  }
}
</style>
